// extracted by mini-css-extract-plugin
export default {"wrapper":"pagination_wrapper__+i352","icon__wrapper":"pagination_icon__wrapper__xvLij","page__item":"pagination_page__item__sSCgR","active":"pagination_active__7vkOm"};